import { render, staticRenderFns } from "./WebPartView.vue?vue&type=template&id=0da6095e"
import script from "./WebPartView.ts?vue&type=script&lang=ts&external"
export * from "./WebPartView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports